/**
 * NetBox Slider Top - Info bar with rotating messages
 */
export class NetBoxSliderTop {
    constructor(container) {
        this.currentIndex = 0;
        this.autoplayTimer = null;
        this.container = container;
        this.messages = container.querySelectorAll('.slider-top-message');
        this.prevBtn = container.querySelector('.slider-top-prev');
        this.nextBtn = container.querySelector('.slider-top-next');
        this.sliderEnabled = container.dataset.sliderEnabled === 'true';
        this.interval = parseInt(container.dataset.interval || '5') * 1000;
        if (this.messages.length > 1 && this.sliderEnabled) {
            this.init();
        }
    }
    init() {
        this.bindEvents();
        this.startAutoplay();
    }
    bindEvents() {
        var _a, _b;
        // Previous button
        (_a = this.prevBtn) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
            this.prevSlide();
            this.resetAutoplay();
        });
        // Next button
        (_b = this.nextBtn) === null || _b === void 0 ? void 0 : _b.addEventListener('click', () => {
            this.nextSlide();
            this.resetAutoplay();
        });
        // Pause on hover
        this.container.addEventListener('mouseenter', () => this.stopAutoplay());
        this.container.addEventListener('mouseleave', () => this.startAutoplay());
        // Keyboard navigation
        document.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') {
                this.prevSlide();
                this.resetAutoplay();
            }
            else if (e.key === 'ArrowRight') {
                this.nextSlide();
                this.resetAutoplay();
            }
        });
    }
    showSlide(index) {
        var _a;
        // Remove active class from all messages
        this.messages.forEach(msg => msg.classList.remove('active'));
        // Add active to current message
        (_a = this.messages[index]) === null || _a === void 0 ? void 0 : _a.classList.add('active');
        this.currentIndex = index;
    }
    nextSlide() {
        const next = (this.currentIndex + 1) % this.messages.length;
        this.showSlide(next);
    }
    prevSlide() {
        const prev = (this.currentIndex - 1 + this.messages.length) % this.messages.length;
        this.showSlide(prev);
    }
    startAutoplay() {
        if (!this.sliderEnabled || this.messages.length <= 1)
            return;
        this.stopAutoplay();
        this.autoplayTimer = window.setInterval(() => {
            this.nextSlide();
        }, this.interval);
    }
    stopAutoplay() {
        if (this.autoplayTimer !== null) {
            clearInterval(this.autoplayTimer);
            this.autoplayTimer = null;
        }
    }
    resetAutoplay() {
        this.stopAutoplay();
        setTimeout(() => this.startAutoplay(), this.interval);
    }
    destroy() {
        this.stopAutoplay();
        // Cleanup event listeners if needed
    }
}
